let claimPolicyRefreshHistoryCols = [
    {
        key: 'dateCreated',
        display: 'Date'
    },
    {
        key: 'createdBy',
        display: 'User'
    }]

export { claimPolicyRefreshHistoryCols }